module.exports = __webpack_public_path__ + "static/img/hdq0610.7c9fbb0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hdq0610.jpg
// module id = VodR
// module chunks = 0